const customBaseUrl = 'https://embedexa-acac-prod-ws.lms.getvymo.com:8123';

export const customWebsocketHost = 'embedexa-acac-prod-ws.lms.getvymo.com:8123';

const stagingBaseUrl = 'https://embedexa-staging-ws.lms.getvymo.com:8123';
const productionBaseUrl = 'https://aci-prod-embedexa.lms.getvymo.com';

const stagingWebsocketHost = 'embedexa-staging-ws.lms.getvymo.com:8123';
const productionWebsocketHost = 'aci-prod-embedexa.lms.getvymo.com';

export const getBaseUrl = (client = '') => {
  if (process.env.APP_ENV === 'production') {
    return client === 'empire' ? customBaseUrl : productionBaseUrl;
  }
  return stagingBaseUrl;
};

export const getWebsocketHost = (client = '') => {
  if (process.env.APP_ENV === 'production') {
    return client === 'empire' ? customWebsocketHost : productionWebsocketHost;
  }
  return stagingWebsocketHost;
};

export const AGENT_API_BASE = 'https://vymo-agents.lms.getvymo.com/api/v1';
export const AGENT_WS_BASE = 'wss://vymo-agents.lms.getvymo.com/api/v1/voice';
